import { ArrowDown } from "lucide-react";

export const fmt = (v) => `€${Math.round(v).toLocaleString()}`;

export const TONE = {
  emerald: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10",
  sky: "text-sky-400 border-sky-500/40 bg-sky-500/10",
  amber: "text-amber-400 border-amber-500/40 bg-amber-500/10",
  violet: "text-violet-400 border-violet-500/40 bg-violet-500/10",
  zinc: "text-zinc-400 border-zinc-600 bg-zinc-500/10",
};

export const tooltipStyle = { backgroundColor: "#18181b", border: "1px solid #27272a", borderRadius: 4, fontSize: 12, fontFamily: "IBM Plex Mono, monospace" };

export const Card = ({ title, sub, children, testId, className = "" }) => (
  <div className={`bg-zinc-900 border border-zinc-800 rounded-md p-5 ${className}`} data-testid={testId}>
    <h3 className="text-sm font-semibold text-zinc-200">{title}</h3>
    {sub && <p className="text-[11px] text-zinc-500 mt-0.5 mb-3">{sub}</p>}
    <div className={sub ? "" : "mt-3"}>{children}</div>
  </div>
);

export const Funnel = ({ title, steps, note, delta, testId }) => (
  <Card title={title} testId={testId}>
    <div className="mt-2">
      {steps.map((s, i) => {
        const v = s.deltaKey ? s.value + (delta[s.deltaKey] || 0) : s.value;
        const changed = s.deltaKey && (delta[s.deltaKey] || 0) > 0;
        return (
          <div key={s.label}>
            <div className={`flex items-center justify-between rounded-sm px-3 py-2 ${changed ? "bg-emerald-500/10 border border-emerald-500/40" : "bg-zinc-950/50 border border-zinc-800/60"}`}>
              <span className="text-[11px] text-zinc-400">{s.label}</span>
              <span className={`font-mono text-sm font-semibold ${changed ? "text-emerald-400" : "text-zinc-200"}`}>
                {s.money ? fmt(v) : v}
              </span>
            </div>
            {i < steps.length - 1 && <div className="flex justify-center py-0.5"><ArrowDown className="w-3 h-3 text-zinc-700" strokeWidth={1.5} /></div>}
          </div>
        );
      })}
    </div>
    {note && <p className="text-[10px] text-zinc-600 mt-3 leading-relaxed">{note}</p>}
  </Card>
);
